import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Organizers APIs
export const getOrganizers = async (searchQuery = "", status = "", params = {}) => {
    try {
        const queryParams = new URLSearchParams();

        if (searchQuery) {
            queryParams.append("search", searchQuery);
        }

        if (status) {
            queryParams.append("status", status);
        }

        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
                // Skip limit if it's 10 (backend default)
                if (key === 'limit' && params[key] === 10) {
                    return;
                }
                queryParams.append(key, params[key]);
            }
        });

        const url = `${apiUrlOne}/organizers/get-all-organizers-admin${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching organizers:", error);
        throw error;
    }
};

export const createOrganizer = async (formData) => {
        try {
            const response = await axios.post(`${apiUrlOne}/organizers`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getOrganizerById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/organizers/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateOrganizer = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/organizers/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteOrganizer = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/organizers/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
